import jsPDF from "jspdf";
import {
  store
} from "../../index";
import moment from "moment";
import {
  imgData
} from "./letterhead";
import Roundy from "../../services/roundy";
var doc = new jsPDF();
const pdfdownload = (vendors, grand_total) => {
  var index = 0;
  var sheetNum = 1;
  var employees = store.getState().employees.employees;
  // You'll need to make your image into a Data URL
  // Use http://dataurl.net/#dataurlmaker
  var doc = new jsPDF();
  var row = 45;
  var grand_total_amount = 0;
  vendors.map((vendor, index, array) => {
    var sub_total_amount = 0;
    if (row + vendor.mat_entries.length * 6 + 21 >= 258) {
      doc.text(90, 266, "Sheet " + sheetNum);
      sheetNum += 1;
      doc.addPage();
      doc.addImage(imgData, "JPEG", 15, 10, 113, 22);
      doc.setFontType("bold");
      doc.setFontSize(12);
      doc.text(160, 20, "Material Charges");
      doc.setFontType("normal");
      doc.text(160, 26, "As of " + moment().format("MM/DD/YYYY"));
      row = 45;
    }
    if (index === 0) {
      doc.addImage(imgData, "JPEG", 15, 10, 113, 22);
      doc.setFontType("bold");
      doc.setFontSize(12);
      doc.text(160, 20, "Material Charges");
      doc.setFontType("normal");
      doc.text(160, 26, "As of " + moment().format("MM/DD/YYYY"));
    }

    doc.setFontSize(14);
    doc.setFont("helvetica");
    doc.setFontType("bold");

    doc.text(28, row, vendor.companyname.toUpperCase());
    doc.setFontSize(12);
    row += 6;
    doc.text(20, row, "WO#");
    doc.text(55, row, "Date");
    doc.text(90, row, "Amount");
    doc.text(125, row, "Mark Up %");
    doc.text(160, row, "Total Charge");
    //+6 pt in Y directopm per entry
    doc.setFontSize(12);
    doc.setFontType("normal");
    // doc.text(160, row - 53, vendor.workOrderNbr);
    //Charge Example
    vendor.mat_entries.map((me, i) => {
      if (i === 30) {
        sheetNum += 1;
        doc.addPage();
        doc.addImage(imgData, "JPEG", 15, 10, 113, 22);
        doc.setFontType("bold");
        doc.setFontSize(12);
        doc.text(160, 20, "Material Charges");
        doc.setFontType("normal");
        doc.text(160, 26, "As of " + moment().format("MM/DD/YYYY"));
        row = 45;
      }
      row += 6;
      doc.text(20, row, me.workordernumber);
      doc.text(55, row, moment(me.datepurchased).format("MM/DD/YYYY"));
      doc.text(90, row, "$ " + Roundy(me.amount));
      doc.text(125, row, "% " + Math.round((me.markuppercent - 1) * 100));
      doc.text(160, row, "$ " + Roundy(me.amount * me.markuppercent));
      sub_total_amount += me.amount;
      grand_total_amount += me.amount;
    });
    row += 6;
    doc.setFontType("bold");
    doc.text(55, row, "Sub Total");
    doc.text(90, row, "$ " + Roundy(sub_total_amount));
    doc.text(125, row, "-");
    doc.text(160, row, "$ " + Roundy(vendor.sub_total));
    row += 6;
    if (index + 1 === array.length) {
      doc.text(55, row, "Grand Total");
      doc.text(90, row, "$ " + Roundy(grand_total_amount));
      doc.text(125, row, "-");
      doc.text(160, row, "$ " + Roundy(grand_total));
      doc.text(100, 266, "Sheet " + sheetNum);
    } else {
      doc.setFontType("normal");
      doc.setLineWidth(0.5);
      doc.line(15, row, 200, row);
    }
    row += 7;
  });

  doc.save("Material Charge Report " + moment().format("MM/DD/YYYY") + ".pdf");
};

export default pdfdownload;


// WEBPACK FOOTER //
// ./src/components/pdf/matReportPDFDownload.js